import { gql } from '@apollo/client';

const collectionQuery = gql`
  query Collection($nftContractAddress: String) {
    collection(id: $nftContractAddress) {
      id
      tokenAddress
      totalOwners
      totalSupply
      commission {
        artistAddress
        commissionBasisPoint
      }
    }
  }
`;

export default collectionQuery;
